import useTranslation from "hooks/useTranslation";
import React from "react";

const TranslatedText = ({ children }) => {
  return <>{useTranslation(children)}</>;
};

export default React.memo(TranslatedText);
